export default __webpack_public_path__ + "static/media/chevron_up_light.bc2539c8.svg";